module.exports = __webpack_public_path__ + "static/img/backButton.53f7450.png";


//////////////////
// WEBPACK FOOTER
// ./static/imgV2/backButton.png
// module id = mN9L
// module chunks = 1